import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import List from '../views/List.vue'
import Search from '../views/Search.vue'
import Ranking from '../views/Ranking.vue'
import Signin from '../views/Signin.vue'
import MyFav from '../views/MyFav.vue'
import About from '../views/About.vue'
import MyList from '../views/MyList.vue'
import Welcome from '../views/Welcome'
// import store from '../store'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    component: Welcome
  },
  {
    path: '/signup',
    name: 'Home',
    component: Home,
    meta: { isPublic: true }
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/list',
    component: List,
    meta: { isPublic: true }
  },
  {
    path: '/search',
    component: Search
  },
  {
    path: '/ranking',
    component: Ranking,
    meta: { isPublic: true }
  },
  {
    path: '/signin',
    component: Signin,
    meta: { isPublic: true }
  },
  {
    path: '/myfavs',
    component: MyFav
  },
  {
    path: '/mylist',
    component: MyList
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
